function unifyValues(server, cloudCode) {

    let MBxxGB = value => Math.round((value / 1024) * 10) / 10;
    let KBxxGB = value => Math.round((value / 1073741824) * 10) / 10;
    let BxxMB = value => Math.round((value / 1048576) * 10) / 10;
    let roundedBxxGB = value => value / 1000000000; // 50000000000 bytes => 50 Gb
    let roundedGBxxTB = value => value / 1000;

    switch (cloudCode) {
        case 'do':
            server.ram = MBxxGB(server.ram);
            break;
        case 'lo':
            server.ram = MBxxGB(server.ram);
            server.diskSize = MBxxGB(server.diskSize);
            server.bandwidth = roundedGBxxTB(server.bandwidth);
            break;
        case 'vu':
            server.ram = MBxxGB(server.ram);
            break;
        case 'scw':
            server.ram = KBxxGB(server.ram);
            server.diskSize = roundedBxxGB(server.diskSize);
            server.network.sum_internet_bandwidth = BxxMB(server.network.sum_internet_bandwidth);
            break;
        case 'azu':
            server.ram = MBxxGB(server.ram);
            server.osDiskSize = MBxxGB(server.osDiskSize);
            server.resourceDiskSize = MBxxGB(server.resourceDiskSize);
            break;
        default:
            break;
    }

    return server;
}

function getAdaptedServerBasics(server) {

    let { ram, cpu, vcpu, ncpu, diskSize, resourceDiskSize, } = server;
    let adaptedCPU = { name: null, value: null, unit: null, icon: 'fas fa-microchip' },
        adaptedRAM = { name: null, value: null, unit: 'Gb', icon: 'fas fa-memory' },
        adaptedStorage = { name: null, value: null, unit: 'Gb', icon: 'fas fa-hdd' };
    // Processor
    if (cpu) adaptedCPU = { ...adaptedCPU, ...{ name: 'CPU', value: cpu } };
    if (vcpu) adaptedCPU = { ...adaptedCPU, ...{ name: 'vCPU', value: vcpu } };
    if (ncpu) adaptedCPU = { ...adaptedCPU, ...{ name: 'nCPU', value: ncpu } };
    // RAM
    if (ram) adaptedRAM = { ...adaptedRAM, ...{ name: 'RAM', value: ram } };
    // Storage
    if (diskSize) adaptedStorage = { ...adaptedStorage, ...{ name: 'Storage', value: diskSize } };
    if (resourceDiskSize) adaptedStorage = { ...adaptedStorage, ...{ name: 'Storage', value: resourceDiskSize } };

    return {
        cpu: adaptedCPU,
        ram: adaptedRAM,
        storage: adaptedStorage,
    };
}

function getAdaptedServerDetails(server, rawServers) {

    let { osDiskSize, maxDataDiskCount, bandwidth, baremetal, dedicated, gpu, network } = server;

    let internetBW = network && !!network['sum_internet_bandwidth'] ? network['sum_internet_bandwidth'] : null;
    let IPv6 = network && typeof network['ipv6_support'] === 'boolean' ? !!network['ipv6_support'] : null;
    let fillSample = (name, value, unit, icon) => {
        return {
            name: !!name ? name : null,
            value: !!value ? value : null,
            unit: !!unit ? unit : null,
            icon: `fas fa-${!!icon ? icon : 'server'}`,
            render: false,
        }
    };
    let defineDedicatedValue = d => {
        let hasServerProp = d.some(i => i === 'server');
        let dedicatedItems = !!d && Array.isArray(d) && !!d.length ? d.join(', ') : '';
        return hasServerProp ? !!d : dedicatedItems
    };
    let details = {
        GPU: fillSample('GPU', gpu, null, 'microchip'),
        OSDisk: fillSample('OS Storage', osDiskSize, 'Gb', 'hdd'),
        maxDisks: fillSample('Max Disks', maxDataDiskCount, 'Gb', 'hdd'),
        IPv6: fillSample('IPv6', IPv6, null, 'network-wired'),
        IBW: fillSample('Internet Bandwidth', internetBW, 'Mb/s', 'wifi'),
        BW: fillSample('Bandwidth', bandwidth, 'TB', 'wifi'),
        BM: fillSample('Baremetal', baremetal, null, 'server'),
        _dedicated: fillSample('Dedicated', defineDedicatedValue(dedicated), null, 'server'),
    };
    // define if some servers are lack of prop present in another to render equal height for each server
    rawServers.map(rawServer => {

        let { network } = rawServer;
        let { IBW, IPv6, OSDisk, maxDisks, BW, BM, _dedicated, GPU } = details;

        if (!GPU.render && !!rawServer['gpu']) GPU.render = true;
        if (!OSDisk.render && !!rawServer['os_disk_size']) OSDisk.render = true;
        if (!maxDisks.render && !!rawServer['max_data_disk_count']) maxDisks.render = true;
        if (!IPv6.render && network && typeof network['ipv6_support'] === 'boolean') IPv6.render = true;
        if (!IBW.render && network && !!network['sum_internet_bandwidth']) IBW.render = true;
        if (!BW.render && !!rawServer['bandwidth']) BW.render = true;
        if (!BM.render && !!rawServer['baremetal']) BM.render = true;
        if (!_dedicated.render && !!rawServer['dedicated']) _dedicated.render = true;
    })

    return details
}

export function adaptServers(raw, cloudCode) {

    let adaptedServers = [];

    raw.map(server => {

        let {
            id, name, description, ram, cpu, vcpu, ncpu, dedicated, prices, bandwidth, locations, baremetal, gpu,
            network, availability, disk_size, os_disk_size, resource_disk_size, max_data_disk_count,
            // is_linux, plan_type, alt_names, per_volume_constraint, volumes_constraint, arch, bandwidth_gb
        } = server;

        let adapted = {
            id: id,
            name: name,
            description: description,
            ram: !isNaN(parseFloat(ram)) ? parseFloat(ram) : null,
            cpu: cpu,
            vcpu: vcpu,
            ncpu: ncpu,
            diskSize: !isNaN(parseFloat(disk_size)) ? parseFloat(disk_size) : null,
            resourceDiskSize: !isNaN(parseFloat(resource_disk_size)) ? parseFloat(resource_disk_size) : null,
            prices: prices,
            gpu: gpu,
            bandwidth: bandwidth,
            locations: locations,
            network: network,
            osDiskSize: os_disk_size,
            maxDataDiskCount: max_data_disk_count,
            baremetal: baremetal,
            dedicated: dedicated,
            availability: availability,
            isLocked: true,
            architecture: server.architecture,
            // arch: arch,
            // bandwidthGb: bandwidth_gb,
            // isLinux: is_linux,
            // planType: plan_type,
            // altNames: alt_names,
            // perVolumeConstraint: per_volume_constraint,
            // volumesConstraint: volumes_constraint,
        };

        adapted = unifyValues(adapted, cloudCode);

        adapted = {
            ...adapted,
            ...{
                adaptedRender: {
                    basic: getAdaptedServerBasics(adapted),
                    details: getAdaptedServerDetails(adapted, raw),
                }
            }
        }

        adaptedServers.push(adapted);
    })

    return adaptedServers
}